module.exports = __webpack_public_path__ + "fonts/lg.ba38ec74.woff";